import { ZomentumEntities } from "@/Contracts";
import {
	CustomViewsMetadata,
	ListPagePostRequest
} from "@/Contracts/UI";
import { includeChildEntities } from "@/Contracts/Utils";
import {
	MyVendorsPaginationResponse,
	MyVendorsResponse
} from "@/Contracts/Marketplace";
import {
	getRequest,
	postRequest
} from "@/Utils/Service/BackendService";
import {
	VendorCompaniesResponse,
	VendorCompany
} from "@/Contracts/Marketplace/Vendor";
import axios, { AxiosResponse } from "axios";

const getVendorDetailsURL = "/v1/marketplace/vendors/:id";
const getJoinedVendorsURL = "v1/marketplace/joined-vendors";
const getMyVendorsURL = "v1/marketplace/vendor/list";
const getMyVendorsPaginationURL = "v1/marketplace/vendor/view";
const getMyVendorsMetaDataURL = "v2/views/metadata?entity_type={entity_type}";
const getVendorsListURL = "/v1/marketplace/vendor/list/";

export const getVendorDetails = async (
	vendorId: string
): Promise<VendorCompany> => {
	try {
		const response: AxiosResponse<VendorCompany> = await axios(
			getRequest(
				getVendorDetailsURL.replace(":id", vendorId),
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getJoinedVendors = async (): Promise<VendorCompaniesResponse> => {
	try {
		const response: AxiosResponse<VendorCompaniesResponse> = await axios(
			getRequest(getJoinedVendorsURL, null, true, false, false)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getMyVendors = async (): Promise<MyVendorsResponse> => {
	try {
		const response: AxiosResponse<MyVendorsResponse> = await axios(
			getRequest(getMyVendorsURL, null, true, false, false)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getVendorsListPost = async (
	vendorRequest: ListPagePostRequest,
	onlyJoinedVendors = false,
	includeSuspended = true
): Promise<MyVendorsPaginationResponse> => {
	try {
		const includedChildEntities = includeChildEntities(
			vendorRequest.included_child_entities
		);
		const vendorsUpdatedURL =
			getMyVendorsPaginationURL + `?${includedChildEntities}`;
		const response: AxiosResponse<MyVendorsPaginationResponse> =
			await axios(
				postRequest(
					`${vendorsUpdatedURL}&joined_vendors=${onlyJoinedVendors.toString()}&include_suspended=${includeSuspended.toString()}`,
					vendorRequest,
					true,
					false,
					false
				)
			);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getVendorsMetaDataRequest =
	async (): Promise<CustomViewsMetadata> => {
		try {
			const response = await axios(
				getRequest(
					getMyVendorsMetaDataURL.replace(
						"{entity_type}",
						ZomentumEntities.VendorCompanies
					),
					null,
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const getVendorList = async (): Promise<VendorCompaniesResponse> => {
	try {
		const response: AxiosResponse<VendorCompaniesResponse> = await axios(
			getRequest(getVendorsListURL, null, true, false, false)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
